import React, {Component} from 'react';
import UserFullName from '../FormGroups/UserFullName';
import BillingAdress from '../FormGroups/BillingAdress';

class BillingStep extends Component{
  constructor(props){
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
  }

  handleChange(event) {
    this.props.changeHandler(event);
  }
  isFormValid(isValid, whereValid) {
    this.props.isValidForm(isValid, whereValid);
  }
  

  render() {
    return (
      <div>
        <hr></hr>
        <h5>Bitte nennen Sie uns hier die abweichende Rechnungsadresse.</h5>
        <hr></hr>
      <UserFullName changeHandler={this.handleChange}
                    submitted={this.props.submitted}
                    state={this.props.state}
                    isValidForm={this.isFormValid} />
      <BillingAdress changeHandler={this.handleChange}
                    submitted={this.props.submitted}
                    state={this.props.state}
                    isValidForm={this.isFormValid} />
      </div>
    );
  }
}


export default BillingStep;


// WEBPACK FOOTER //
// ./src/components/Steps/DivergentBillingStep.js